import { useState } from "react";
import { apiURL } from "../../consts/URLs";
import { urlRequestParamBuilder } from "../../utils/transformMethods";
import { GET_USER, USERS, LOGIN, USER, SHARED_ZIP } from "../endpointList";
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const useZip = () => {
  const [getSharedZipResponse, setGetSharedZipResponse] = useState<any>();

  const getSharedZip = (tempToken: string, type: string) => {
    const params = urlRequestParamBuilder({ type: type, token: tempToken });
    const url = `${apiURL}/${SHARED_ZIP}${params}`;
    let myHeaders = new Headers();
    myHeaders.append("Content-type", "application/x-zip; charset=UTF-8");
    fetch(url, { method: "GET", headers: myHeaders }).then((res) =>
      setGetSharedZipResponse(res)
    );
  };

  const RESPONSES = {
    getSharedZipResponse,
  };

  const RESULTS = {};

  const CTAs = {
    getSharedZip,
  };

  return { RESPONSES, RESULTS, CTAs };
};
export default useZip;
